/**
 * Short-lived in-memory cache for analytical dashboard responses.
 *
 * The dashboard's aggregates are expensive to compute and barely move between
 * page views, so serving a recent one instantly beats waiting on a fresh
 * aggregation over the whole student population. Anything that changes the
 * numbers — a different filter, a different institution — produces a different
 * key and misses the cache.
 *
 * Memory only: the payloads are large and are never worth persisting past a
 * page reload.
 */
export const CHART_CACHE_TTL = 5 * 60 * 1000;

const store = new Map();

const now = () => Date.now();

export const buildChartCacheKey = (url, params) => {
  const normalised = {};
  Object.keys(params || {})
    .sort()
    .forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        normalised[key] = value;
      }
    });
  return `${url}|${JSON.stringify(normalised)}`;
};

export const readChartCache = (key) => {
  const entry = store.get(key);
  if (!entry) {
    return undefined;
  }
  if (entry.expiresAt <= now()) {
    store.delete(key);
    return undefined;
  }
  return entry.value;
};

export const writeChartCache = (key, value, ttl = CHART_CACHE_TTL) => {
  store.set(key, { value, expiresAt: now() + ttl });
};

export const clearChartCache = () => {
  store.clear();
};
